(() => {
  const contextElement = document.getElementById('pp-conversion-context');
  if (!contextElement || contextElement.dataset.ready) return;
  contextElement.dataset.ready = 'true';
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) document.dispatchEvent(new Event('pp:privacy-ready'));
    });
  }
  const context = JSON.parse(contextElement.textContent);
  const services = ['screen-printing', 'embroidery', 'dtg-printing', 'dtf-printing'];
  const contextual = context.product || context.path.startsWith('/collections/') || services.some(service => context.path === `/pages/${service}`);
  if (contextual && context.title) document.querySelectorAll('a[href]').forEach(link => {
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.pathname !== '/pages/contact' || destination.searchParams.has('product')) return;
    destination.searchParams.set('product', context.title);
    link.href = destination.href;
  });
  const publish = (name, detail = {}) => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    try { Promise.resolve(window.Shopify.analytics.publish(name, { page: context.path, ...detail })).catch(() => {}); } catch {}
  };
  const destinationPaths = new Set([...document.querySelectorAll('[data-showcase-choice]')].map(link => new URL(link.href).pathname));
  let quoteStarted = false;
  const quoteStart = () => { if (!quoteStarted) { quoteStarted = true; publish('pp_quote_start'); } };
  document.addEventListener('click', event => {
    if (event.defaultPrevented) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin) return;
    if (document.body.classList.contains('template-index')) {
      const section = link.closest('[data-section-id], .shopify-section');
      const detail = { destination: destination.pathname, section: section?.dataset.sectionId || section?.id || 'homepage' };
      if (destination.pathname.startsWith('/products/')) publish('pp_product_selection', detail);
      else if (destination.pathname.startsWith('/collections/')) publish('pp_category_selection', detail);
      else if (services.some(service => destination.pathname === `/pages/${service}`)) publish('pp_service_selection', detail);
      else if (destination.pathname === '/pages/contact') publish('pp_homepage_cta', detail);
    }
    if (destination.pathname === '/pages/contact') publish('pp_quote_click');
    else if (link.matches('.pp-hero__cta--primary')) publish('pp_shop_click');
    else if (destinationPaths.has(destination.pathname)) publish('pp_destination_click', { destination: destination.pathname });
  });
  const form = document.querySelector('.pp-contact form');
  form?.addEventListener('focusin', quoteStart, { once: true });
  if (form?.querySelector('.pp-contact__success')) {
    const successKey = 'pp-quote-success';
    let attempt;
    try { attempt = sessionStorage.getItem('pp-quote-attempt'); } catch {}
    let reported = false;
    const reportSuccess = () => {
      if (reported || !attempt || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
      try { if (sessionStorage.getItem(successKey) === attempt) return; } catch {}
      if (typeof window.Shopify?.analytics?.publish !== 'function') return;
      publish('pp_quote_success');
      reported = true;
      try { sessionStorage.setItem(successKey, attempt); } catch {}
    };
    reportSuccess();
    document.addEventListener('visitorConsentCollected', reportSuccess);
    document.addEventListener('pp:privacy-ready', reportSuccess);
  }
})();